export default "__VITE_ASSET__Cs54y_89__"